import type { Chart } from '@usacsmideo/types';
import QRCode from 'react-qr-code';

type CardBackProps = {
  chart: Chart;
  patientId: string;
  mode: 'preview' | 'final';
};

export function CardBack({ chart, patientId, mode }: CardBackProps) {
  const documentsUrl = `${import.meta.env.VITE_PUBLIC_STORAGE_URL}/${patientId}/filesForCard.pdf`;

  return (
    <div
      id="card-back"
      className="i bg-true-white @container my-4 flex aspect-[1.586] w-[300px] flex-col rounded-xl outline-solid sm:w-[540px]"
    >
      <div id="card-back-container" className="flex flex-row">
        <div id="card-back-left" className="ml-2 flex w-1/2 flex-col text-[0.5rem] sm:text-base">
          <div id="card-back-logo" className="mt-2">
            <img
              src="https://storage.googleapis.com/web-console-mideoid-public/logos/defaultSecondaryLogo.png"
              alt="MIDEO Logo"
              className="h-8 sm:h-14"
            />
          </div>
          <div id="patient-sig-area" className="mt-0 sm:mt-2">
            <img src={chart.PATIENT_SIGNATURE.signature1DataURI} alt="Patient Signature" className="h-4 sm:h-8" />
            <p className="text-[.45rem] sm:text-[.7rem]">Patient Signature</p>
            <p className="text-[.45rem] sm:text-[.7rem]">MM-DD-YYYY</p>
          </div>
          <div id="witness-sig-area" className="mt-0 sm:mt-2">
            {chart.WITNESS_SIGNATURE.signature1DataURI ? (
              <img src={chart.WITNESS_SIGNATURE.signature1DataURI} alt="Witness Signature" className="h-4 sm:h-8" />
            ) : (
              <p id="waiting" className="text-xs font-bold text-red-500">
                AWAITING SIGNATURE
              </p>
            )}
            <p className="text-[.45rem] sm:text-[.7rem]">Witness Signature</p>
            <p className="text-[.45rem] sm:text-[.7rem]">MM-DD-YYYY</p>
          </div>
          <div id="witness-sig-2-area" className="mt-0 sm:mt-2">
            {chart.WITNESS_SIGNATURE.signature2DataURI ? (
              <img src={chart.WITNESS_SIGNATURE.signature2DataURI} alt="Witness Signature" className="h-4 sm:h-8" />
            ) : (
              <p id="waiting" className="text-xs font-bold text-red-500">
                AWAITING SIGNATURE
              </p>
            )}
            <p className="text-[.45rem] sm:text-[.7rem]">Witness Signature</p>
            <p className="text-[.45rem] sm:text-[.7rem]">MM-DD-YYYY</p>
          </div>
          <div id="dr-sig-area" className="mt-0 sm:mt-2">
            <p id="dr-sig" className="text-[.5rem] font-bold text-red-500 lg:text-[.75rem]">
              SHOWN ON CARD
            </p>
            <p className="text-[.45rem] sm:text-[.7rem]">Physician Signature</p>
            <p className="text-[.45rem] sm:text-[.7rem]">MM-DD-YYYY</p>
          </div>
        </div>
        <div id="card-back-right" className="flex w-1/2 flex-col">
          <div id="lost-info" className="mt-2 flex w-full flex-col items-end pr-4 text-[.5rem] sm:text-base">
            <p id="if-lost">If lost, please contact</p>
            <p id="patient-name">
              {`${chart.PATIENT_INFO_1.firstName} `}
              {chart.PATIENT_INFO_1.middleInitial ? `${chart.PATIENT_INFO_1.middleInitial}. ` : ' '}
              {`${chart.PATIENT_INFO_1.lastName}`}
            </p>
            <p id="street-address">{chart.PATIENT_INFO_2.streetAddress}</p>
            <p id="city-state-zip">{`${chart.PATIENT_INFO_2.city}, ${chart.PATIENT_INFO_2.state} ${chart.PATIENT_INFO_2.ZIP}`}</p>
            <p id="alt-contact">Alternate Contact:</p>
            <p id="see-front">See Healthcare Agent info on</p>
            <p id="front">front of card.</p>
          </div>
          {!chart?.STATUS?.emergencyAccessTokenId && (
            <div id="back-qr-code" className="mt-4 ml-12 flex justify-end pr-4 sm:ml-28">
              {mode === 'preview' ? (
                <img src="/sampleQR.png" alt="Sample QR Code" className="h-18 sm:h-32" />
              ) : (
                <QRCode size={256} className="h-18 w-18 sm:h-32 sm:w-32" value={documentsUrl} viewBox="0 0 256 256" />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
